<template>
  <div class="wrap">
    <div class="nav">
      <div class="game-logo"></div>
      <div class="menu">
        <div class="filterMenu" v-for="(item, idx) in navlist" :key="idx">
          <ul class="header-nav_list" v-if="item.lang == language">
            <li
              class="header-nav_item"
              v-for="Mitem in item.list"
              :key="Mitem.id"
              @click="handleNav(Mitem)"
            >
              <img
                :src="activeIndex == Mitem.id ? Mitem.activeUrl : Mitem.url"
              />
            </li>
          </ul>
        </div>
      </div>
      <!-- 语言切换 -->
      <div class="lang_box" @mouseover="showMenu = true"></div>

      <div class="lang_list" v-show="showMenu" @mouseleave="showMenu = false">
        <div
          v-for="(item, index) in languageList"
          :key="index"
          class="lang_item"
          :id="item.key"
          @click="changeLangEvent(item)"
        >
          {{ item.val }}
        </div>
      </div>
    </div>

    <div class="page">
      <swiper
        :options="swiperOption"
        ref="goodSwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <!-- <div style="border: 10px solid orangered; height: 100vh"></div> -->
          <layer1 :language="language" @handleVideo="videoFlag = true" />
        </swiper-slide>
        <!-- <swiper-slide>
          <layer2 :language="language" />
        </swiper-slide> -->
        <swiper-slide>
          <layer3 :language="language" />
        </swiper-slide>
        <swiper-slide>
          <layer4 :language="language" :changeLang="changeLang" />
        </swiper-slide>
        <swiper-slide id="copyright">
          <copyright :language="language" />
        </swiper-slide>
      </swiper>
    </div>
    <!-- 首页视频 -->
    <div
      v-if="videoFlag"
      class="model position-fixed"
      @click="videoFlag = false"
    >
      <div class="v-txt">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/J5bqNxreAKM?si=N0DYtBYojs96HWx8&amp;start=7"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>

    <!-- share icon -->
    <div class="share-icon cursor">
      <div class="sns-fb icon-size" @click="facebook_page('fb')"></div>
      <div class="sns-dc icon-size" @click="Discord_page('dc')"></div>
      <div class="sns-ytu icon-size" @click="youtube_page('yt')"></div>
      <div class="sns-twi icon-size" @click="Twitter_page('twi')"></div>
    </div>
    <!-- btn -->
    <div
      class="share-btn cursor"
      :class="activeIndex != 1 ? 'iconBlock' : 'iconNone'"
    >
      <img
        :src="require('../assets/img/nav/ios/ios-' + language + '.png')"
        alt=""
        srcset=""
        @click="AS_reg('ios')"
      />
      <img
        :src="require('../assets/img/nav/gg/gg-' + language + '.png')"
        alt=""
        srcset=""
        @click="GP_reg('gp')"
      />
    </div>
  </div>
</template>

<script>
import layer1 from "./publicComponents/layer1";
// import layer2 from "./publicComponents/layer2";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import copyright from "./publicComponents/copyright";
import * as swiperAni from "../commonFunction/animate.js";

let _y = 0;
let _isEnd = false;

export default {
  components: {
    layer1,
    // layer2,
    layer3,
    layer4,
    copyright
  },
  data() {
    let that = this;
    return {
      // 默认语言是英语
      language: localStorage.getItem("sof_locale") || "en",
      languageList: [
        {
          id: 1,
          key: "en",
          val: "English"
        },
        {
          id: 2,
          key: "de",
          val: "Deutsch"
        },
        {
          id: 3,
          key: "fr",
          val: "Français"
        },
        {
          id: 4,
          key: "es",
          val: "Español"
        },
        {
          id: 5,

          key: "pt",
          val: "Português"
        },
        {
          id: 6,
          key: "cn",
          val: "简体中文"
        }
      ],
      // menu
      navlist: [
        {
          lang: "en",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/en/1.png"),
              activeUrl: require("../assets/img/nav/en/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/en/2.png"),
            //   activeUrl: require("../assets/img/nav/en/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/en/3.png"),
              activeUrl: require("../assets/img/nav/en/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/en/4.png"),
              activeUrl: require("../assets/img/nav/en/4-active.png")
            }
          ]
        },
        {
          lang: "de",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/de/1.png"),
              activeUrl: require("../assets/img/nav/de/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/de/2.png"),
            //   activeUrl: require("../assets/img/nav/de/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/de/3.png"),
              activeUrl: require("../assets/img/nav/de/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/de/4.png"),
              activeUrl: require("../assets/img/nav/de/4-active.png")
            }
          ]
        },
        {
          lang: "fr",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/fr/1.png"),
              activeUrl: require("../assets/img/nav/fr/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/fr/2.png"),
            //   activeUrl: require("../assets/img/nav/fr/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/fr/3.png"),
              activeUrl: require("../assets/img/nav/fr/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/fr/4.png"),
              activeUrl: require("../assets/img/nav/fr/4-active.png")
            }
          ]
        },
        {
          lang: "es",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/es/1.png"),
              activeUrl: require("../assets/img/nav/es/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/es/2.png"),
            //   activeUrl: require("../assets/img/nav/es/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/es/3.png"),
              activeUrl: require("../assets/img/nav/es/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/es/4.png"),
              activeUrl: require("../assets/img/nav/es/4-active.png")
            }
          ]
        },
        {
          lang: "pt",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/pt/1.png"),
              activeUrl: require("../assets/img/nav/pt/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/pt/2.png"),
            //   activeUrl: require("../assets/img/nav/pt/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/pt/3.png"),
              activeUrl: require("../assets/img/nav/pt/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/pt/4.png"),
              activeUrl: require("../assets/img/nav/pt/4-active.png")
            }
          ]
        },
        {
          lang: "cn",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/cn/1.png"),
              activeUrl: require("../assets/img/nav/cn/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/cn/2.png"),
            //   activeUrl: require("../assets/img/nav/cn/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/cn/3.png"),
              activeUrl: require("../assets/img/nav/cn/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/cn/4.png"),
              activeUrl: require("../assets/img/nav/cn/4-active.png")
            }
          ]
        }
      ],
      videoFlag: false,
      // swiper
      nextShow: true,
      swiperOption: {
        direction: "vertical",
        slidesPerView: "auto",
        allowTouchMove: false,
        slideToClickedSlide: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        mousewheel: true, //开启鼠标
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        breakpoints: {
          780: {
            allowTouchMove: true
          }
        },
        on: {
          init: function() {
            swiperAni.swiperAnimateCache(this); //隐藏动画元素
            swiperAni.swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionStart: function() {
            swiperAni.swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          }
        }
      },

      activeIndex: 1,
      // 切换语言
      showMenu: false,
      eventsAuto: false,
      changeLang: 0
    };
  },
  created() {
    this.initDataGeo();
    this.common.langTitle(this.language);
  },
  updated() {},

  mouthed() {},
  watch: {},
  computed: {},
  methods: {
    // 切换语言
    changeLangEvent(item) {
      this.changeLang = item.id;
      localStorage.setItem("sof_locale", item.key);
      this.$i18n.locale = localStorage.getItem("sof_locale");
      this.language = item.key;

      // 多语言标题栏切换
      this.common.langTitle(item.key);
    },
    // 菜单
    handleNav(val) {
      this.activeIndex = val.id;
      const hcon = this.$refs.goodSwiper.swiper;
      if (val.id == 1) {
        hcon.slideTo(0, 300);
      }
      if (val.id == 2) {
        hcon.slideTo(1, 300);
      }
      if (val.id == 3) {
        hcon.slideTo(2, 300);
      }
      if (val.id == 4) {
        hcon.slideTo(3, 300);
      }
      // this.$emit('handleNavIndex', val)
    },
    // end~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // 预注册错误弹出框出来后，禁止页面滑动
    // changeSilderDisable() {
    //   this.$refs.goodSwiper.swiper.mousewheel.disable();
    // },
    // changeSilderEnable() {
    //   this.$refs.goodSwiper.swiper.mousewheel.enable();
    // },

    Twitter_page(val) {
      this.common.goShare(val);
    },
    Discord_page(val) {
      this.common.goShare(val);
    },
    facebook_page(val) {
      this.common.goShare(val);
    },
    youtube_page(val) {
      this.common.goShare(val);
    },
    AS_reg(val) {
      this.common.goShare(val);
    },
    GP_reg(val) {
      this.common.goShare(val);
    },
    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.activeIndex = mainActiveIndex + 1;
      // if (mainActiveIndex == 1) {
      //   // this.initData();
      // }
      // if (mainActiveIndex == 2) {
      //   // this.character();
      // }
    },
    // 打开角色介绍页时触发
    // character() {
    //   gtag("event", "character");
    // },
    // info 接口获取数据
    initDataGeo() {
      this.$axios({
        method: "post",
        url: "geo",
        data: {},
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
            // CountryCode ： 语言
            // 德国 DE： 德语 de
            // 巴西 BR ：葡语 pt
            // 法国FR：法语fr
            // 阿根廷AR：西语es
            let cGeo = res.data.data.CountryCode;
            if (cGeo == "DE") {
              this.language = cGeo;
              localStorage.setItem("sof_locale", "de");
            } else if (cGeo == "BR") {
              this.language = "pt";
              localStorage.setItem("sof_locale", "pt");
            } else if (cGeo == "FR") {
              this.language = "fr";
              localStorage.setItem("sof_locale", "fr");
            } else if (cGeo == "AR" || cGeo == "MX") {
              this.language = "es";
              localStorage.setItem("sof_locale", "es");
            } else {
              this.language = "en";
              localStorage.setItem("sof_locale", "en");
            }
          }
        })
        .catch(err => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    }
  }
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #000;

  #copyright {
    height: 65px;
    width: 100%;
  }

  // 轮播

  .page {
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }

  .iconNone {
    display: none;
  }
  .iconBlock {
    display: block;
  }
  .share-btn {
    position: absolute;
    right: 2vw;
    bottom: 2vw;
    img {
      width: 227px;
      height: 66px;
      display: block;
      margin-bottom: 0.5vw;
    }
  }
  .share-icon {
    position: absolute;
    right: 2vw;
    top: 60%;
    transform: translate(0, -50%);

    .icon-size {
      width: 53px;
      height: 52px;
      margin-bottom: 0.8vw;
    }
    .sns-fb {
      background-image: url("../assets/img/nav/sns1-before.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns1-choose.png");
        background-size: 100% 100%;
      }
    }
    .sns-dc {
      background-image: url("../assets/img/nav/sns2-before.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns2-choose.png");
        background-size: 100% 100%;
      }
    }
    .sns-ytu {
      background-image: url("../assets/img/nav/sns3-before.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns3-choose.png");
        background-size: 100% 100%;
      }
    }
    .sns-twi {
      background-image: url("../assets/img/nav/sns4-before.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns4-choose.png");
        background-size: 100% 100%;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .share-icon {
    top: 50% !important;
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .share-icon {
    top: 50% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue